'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _pricingLevelFeature = require('../pricing-level-feature');

var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);

var _contactUsButton = require('../contact-us-button');

var _contactUsButton2 = _interopRequireDefault(_contactUsButton);

var _pricingIconPhone2x = require('../pricing-icon-phone@2x.png');

var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PlanLevelEnterprise = _react2['default'].createClass({
    displayName: 'PlanLevelEnterprise',


    propTypes: {
        'onSuccess': _react2['default'].PropTypes.func
    },

    getInitialState: function getInitialState() {
        return {
            expanded: false
        };
    },
    onLevelClick: function onLevelClick() {
        this.setState({ expanded: !this.state.expanded });
    },
    render: function render() {
        var bodyClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-12': true,
            'columns': true,
            'expanded': this.state.expanded
        });
        var levelClasses = (0, _classnames2['default'])({
            'small-6': true,
            'medium-4': true,
            'medium-offset-1': true,
            'large-12': true,
            'large-offset-0': true,
            'columns': true,
            'level-title': true
        });
        var arrowContainerClasses = (0, _classnames2['default'])({
            'arrow-container': true,
            'hide-for-large-up': true,
            'hide-for-small': true,
            'small-2': true,
            'medium-1': true,
            'columns': true
        });
        var arrowClasses = (0, _classnames2['default'])({
            'l-vertical-align': true,
            'arrow': true,
            'expanded': this.state.expanded
        });
        var contactUsClasses = (0, _classnames2['default'])({
            'phone-container': true,
            'hide-for-large-up': true,
            'small-6': true,
            'medium-5': true,
            'medium-offset-1': true,
            'columns': true,
            'level-price': true
        });
        var lookingForMoreClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-10': true,
            'small-centered': true,
            'columns': true,
            'looking-for-more': true
        });

        var mainFeature = '';
        var noFeatures = true;
        if (this.props.plan.main_feature) {
            var name = this.props.plan.main_feature.name ? this.props.plan.main_feature.name : name;
            var detail = this.props.plan.main_feature.detail ? this.props.plan.main_feature.detail : null;
            var number = this.props.plan.main_feature.number ? this.props.plan.main_feature.number : null;
            mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'main-feature', expanded: this.state.expanded });
            noFeatures = false;
        }

        var features = '';
        if (this.props.plan.features) {
            features = this.props.plan.features.map(function (feature, i) {
                var name = feature.name ? feature.name : name;
                var detail = feature.detail ? feature.detail : null;
                var number = feature.number ? feature.number : null;
                return _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.plan.name, detail: detail, number: number, key: 'feature' + i, expanded: this.state.expanded });
            }.bind(this));
        }

        var additionalFeatures = _react2['default'].createElement(
            'div',
            { className: 'additional-features small-12 columns block' },
            this.props.plan.additional_features
        );

        var phoneNumberClasses = (0, _classnames2['default'])({
            'contact-us-phone-number': true,
            'l-nowrap': true,
            'no-features-padding': noFeatures
        });

        // Currently locked to 3 columns. To extend to different levels, cf pricing-level-corporate.jsx (DB)
        var topLevelClasses = 'm-pricing-level signup-plan small-12 medium-12 large-4 columns';

        return _react2['default'].createElement(
            'div',
            { className: topLevelClasses },
            _react2['default'].createElement(
                'div',
                { className: 'm-pricing-level--header small-12 columns block', onClick: this.onLevelClick },
                _react2['default'].createElement(
                    'div',
                    { className: levelClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'level-title l-vertical-align-wrapper' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'l-vertical-align' },
                            this.props.plan.name.toUpperCase()
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'subheader' },
                        this.props.plan.subheader
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: contactUsClasses },
                    !this.state.expanded && _react2['default'].createElement(_contactUsButton2['default'], {
                        timePeriod: this.state.timePeriod,
                        pricingSource: this.props.pricingSource,
                        modalHeaderText: 'Contact Us for an Enterprise Plan',
                        onSuccess: this.props.onSuccess,
                        buttonText: 'Contact Us',
                        onClick: function onClick(e) {
                            return e.stopPropagation();
                        }
                    })
                ),
                _react2['default'].createElement(
                    'div',
                    { className: arrowContainerClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'level-title l-vertical-align-wrapper' },
                        _react2['default'].createElement(
                            'div',
                            { className: arrowClasses },
                            '\xA0'
                        )
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: bodyClasses },
                _react2['default'].createElement(
                    'div',
                    { className: 'first-section block' },
                    _react2['default'].createElement(
                        'div',
                        { className: lookingForMoreClasses },
                        'Looking for more?'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'sales-team-blurb' },
                        'Our Sales team can help find the perfect plan for you.'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'block' },
                        _react2['default'].createElement(_contactUsButton2['default'], {
                            timePeriod: this.state.timePeriod,
                            pricingSource: this.props.pricingSource,
                            modalHeaderText: 'Contact Us for an Enterprise Plan',
                            onSuccess: this.props.onSuccess,
                            buttonText: 'Contact Us' })
                    ),
                    mainFeature
                )
            ),
            features,
            additionalFeatures
        );
    }
});

module.exports = PlanLevelEnterprise;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/plan-level-enterprise.jsx
 ** module id = 1147
 ** module chunks = 0
 **/